// extracted by mini-css-extract-plugin
module.exports = {"changePassword":"ChangePassword_changePassword__dGaF9"};